import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import { Form } from 'antd';
import BtnBlock from './components/BtnBlock';
import NameField from './components/NameField';
import CustomerSelect from './components/CustomerSelect';
import RestaurantsMultipleSelect from './components/RestaurantsMultipleSelect/RestaurantsMultipleSelect';
import DishesMultipleSelect from './components/DishesMultipleSelect/DishesMultipleSelect';
import ComboItemsField from './components/ComboItemsField/ComboItemsField';
import UpperLimitField from './components/UpperLimitField';
import LowerLimitField from './components/LowerLimitField';
import { preventDefaultForEnterKey } from 'utils/helpers';
import {
	CreateComboGroupContext,
	ICreateComboGroupContext,
} from '../../../../../createComboGroupState/createComboGroupContext';
import style from './InputFields.module.scss';

const InputFields: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		setCustomer,
		setFetchedCustomers,
		setRestaurants,
		setFetchedRestaurants,
		setDishes,
		setFetchedDishes,
		changeName,
		setComboItems,
		setFetchedComboItems,
		updateComboItems,
		changeUpperLimit,
		changeLowerLimit,
		selectedCustomer,
		selectedRestaurants,
		selectedDishes,
		name,
		selectedComboItems,
		upperLimit,
		lowerLimit,
		translations,
		fetchedComboItems,
		defaultCustomerLanguage,
	} = useContext<ICreateComboGroupContext>(CreateComboGroupContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			selectedCustomer,
			selectedRestaurants,
			selectedDishes,
			name,
			selectedComboItems,
			upperLimit,
			lowerLimit,
		});
	}, [selectedCustomer, selectedRestaurants, selectedDishes, name, selectedComboItems, upperLimit, lowerLimit]);

	const submit = async () => {
		const defaultTranslationIsEmpty =
			translations.find((translation) => translation.languageId === defaultCustomerLanguage?.id)?.name === '';
		if (defaultTranslationIsEmpty) {
			changeTypeOfModalWindow('defaultTranslationIsEmpty');
			return;
		}

		setDataForSubmit({
			name,
			upLimit: Number(upperLimit),
			downLimit: Number(lowerLimit),
			customerId: selectedCustomer || '',
			restaurantIds: selectedRestaurants,
			dishIds: selectedDishes,
			comboItemIds: selectedComboItems,
			translations,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<CustomerSelect setCustomer={setCustomer} setFetchedCustomers={setFetchedCustomers} />
					<RestaurantsMultipleSelect
						selectedCustomer={selectedCustomer}
						selectedRestaurants={selectedRestaurants}
						setRestaurants={setRestaurants}
						setFetchedRestaurants={setFetchedRestaurants}
					/>
					<DishesMultipleSelect
						selectedDishes={selectedDishes}
						selectedCustomer={selectedCustomer}
						setDishes={setDishes}
						setFetchedDishes={setFetchedDishes}
					/>
					<NameField changeName={changeName} />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="comboItemHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<ComboItemsField
						selectedComboItems={selectedComboItems}
						fetchedComboItems={fetchedComboItems}
						selectedRestaurants={selectedRestaurants}
						setComboItems={setComboItems}
						setFetchedComboItems={setFetchedComboItems}
						updateComboItems={updateComboItems}
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="limitsHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<div className={style.row}>
						<UpperLimitField changeUpperLimit={changeUpperLimit} />
						<LowerLimitField changeLowerLimit={changeLowerLimit} />
					</div>
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};

export default InputFields;
